/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "../../../../providers/machine";
import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const RolesContext = React.createContext({});
export let getRolesMachine: any;

const MODULE_NAME = "machines.roles";
const log: any = LoggerModule?.getInstance();

export const useSMRoles = (_context: any) => {
    useEffect(() => {
        getRolesMachine.send({ type: "START" });
    }, []);

    let _machineConfig: any = MACHINE_CONFIG;
    if (_machineConfig && _machineConfig?.context) {
        _machineConfig.context = {
            ..._machineConfig.context,
            ...(_context || {}),
        };
    }

    //@ts-ignore
    getRolesMachine = useMachine(_machineConfig, { services, actions });

    return {
        getRolesMachine,
        getRolesState: getRolesMachine?.state,
        getRolesContext: getRolesMachine?.context,
    };
};
